import { ADD_HOLIDAYS, GET_HOLIDAYS_LIST, GET_SINGLE_HOLIDAYS_LIST } from "../actions/HolidayActions";

const initialState = {// initialize states
  List: [],
  singleHoliday: [],
};

const HolidayReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_HOLIDAYS_LIST: { // save holiday list into state
      return { ...state, List: action.payload.data ? action.payload.data : [] };
    }
    case GET_SINGLE_HOLIDAYS_LIST: { // save single holiday data into state
      return { ...state, singleHoliday: action.payload.data ? action.payload.data : [] };
    }
    case ADD_HOLIDAYS: {
      return { ...state };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default HolidayReducer;
